module.exports = __webpack_public_path__ + "img/winewikiBig.afad94a9.png";